import React from "react";
import Modal from "../Modal";

const maxWidths = {
  xs: "max-w-xs",
  sm: "max-w-sm",
  md: "max-w-md",
  lg: "max-w-lg",
  xl: "max-w-xl",
  "3xl": "max-w-3xl",
  false: "",
};

const Dialog = ({
  open,
  onClose,
  children,
  className = "",
  maxWidth = "sm",
  fullWidth = false,
  ...rest
}) => (
  <Modal
    open={open}
    onClose={onClose}
    className={`items-center justify-center p-4 ${className}`}
  >
    <div
      role="dialog"
      {...rest}
      // <form> entre o dialog e DialogContent precisa repassar o flex para o conteúdo rolar
      className={`flex max-h-[90vh] flex-col overflow-y-auto rounded-xl [&>form]:flex [&>form]:min-h-0 [&>form]:flex-1 [&>form]:flex-col bg-farmazon-surface text-farmazon-text shadow-lg ${
        fullWidth ? "w-full" : ""
      } ${maxWidths[maxWidth] ?? maxWidths.sm}`}
    >
      {children}
    </div>
  </Modal>
);

export const DialogTitle = ({ className = "", children, ...rest }) => (
  <div
    className={`shrink-0 border-b border-farmazon-border px-6 py-4 text-lg font-semibold ${className}`}
    {...rest}
  >
    {children}
  </div>
);

export const DialogContent = ({ className = "", dividers, children, ...rest }) => (
  <div
    className={`min-h-0 flex-1 overflow-y-auto px-6 py-4 ${
      dividers ? "border-y border-farmazon-border" : ""
    } ${className}`}
    {...rest}
  >
    {children}
  </div>
);

export const DialogActions = ({ className = "", children, ...rest }) => (
  <div
    className={`flex shrink-0 items-center justify-end gap-2 border-t border-farmazon-border px-6 py-3 ${className}`}
    {...rest}
  >
    {children}
  </div>
);

export default Dialog;
